import axios from 'axios';
import { SERVER } from '../const';
import CacheHelper from '../helpers/CacheHelper';

async function getShopDetails(shopId) {
  const cacheKey = `shop-details-${shopId}`;
  const cache = CacheHelper.get(cacheKey);
  if (cache) {
    return cache;
  }

  const resp = await axios.get(`${SERVER.URL}/public/shops/${shopId}`);
  const data = resp.data;

  CacheHelper.store(cacheKey, data);
  return data;
}

async function getShopProfile(shopId) {
  const cacheKey = `shop-profile-${shopId}`;
  const cache = CacheHelper.get(cacheKey);
  if (cache) return cache;

  const resp = await axios.get(`${SERVER.URL}/api/public/shops/${shopId}/shop_profile/`);
  const data = resp.data;

  CacheHelper.store(cacheKey, data);
  return data;
}

async function getNearestShops(latitude, longitude, limit = 50, distance = 50, requireCoords = false, cityId = null) {
  const params = { limit };
  if (latitude && longitude) {
    params.latitude = latitude;
    params.longitude = longitude;
    params.distance = distance;
  }
  if (requireCoords) {
    params.require_coords = true;
  }
  if (cityId) {
    params.city_id = cityId;
  }
  const resp = await axios.get(`${SERVER.URL}/api/public/shops/`, { params });
  return resp.data?.data || resp.data;
}

async function getGlobalLocations() {
  const resp = await axios.get(`${SERVER.URL}/api/public/locations/`);
  return resp.data?.data || resp.data;
}

async function getGlobalCategories() {
  const resp = await axios.get(`${SERVER.URL}/api/public/categories/`);
  return resp.data?.data || resp.data;
}

const HOST_SHOP_MAP = {
  'adam.cart.sanoft.com': 1217,
  'nauri-care.cart.sanoft.com': 2523,
  'ulcc.cart.sanoft.com': 2718,
  'bista.in': 3745,
  'www.bista.in': 3745,
};

function lookupShopByHost(hostname) {
  const cleanHost = hostname?.split(':')[0];
  const shopId = HOST_SHOP_MAP[hostname] || HOST_SHOP_MAP[cleanHost];
  if (shopId) {
    return { shopId };
  }
  return null;
}

async function getCities() {
  const resp = await axios.get(`${SERVER.URL}/api/public/cities/`);
  return resp.data?.data || resp.data;
}

const ShopService = {
  getShopDetails,
  getShopProfile,
  getNearestShops,
  getCities,
  getGlobalLocations,
  getGlobalCategories,
  lookupShopByHost
};

export default ShopService;
